import { resize } from '@/frontend/utils/parseReferences';
import { Operation } from '@/backend/models/operation';
import { useEffect } from 'react';
import { buildInterpolatedString } from '../parameters/ParameterReference';

export function TextItemRun(props: { initItem: Operation }) {
  const { initItem } = props;

  useEffect(() => {
    resize(`content-${initItem.id}`);
  }, [initItem.id]);

  return (
    <div className="mt-1">
      { buildInterpolatedString(initItem.content, initItem).map(part => part) }
    </div>
  );
}
